const constants = {
    VARIANTS: {
        LINK: 'link',
        CARD: 'card',
        HIGHLIGHT: 'highlight'
    }
};

export default constants;
